const t = (r, e) => e ? r * 100 / e : 0, n = (r, e) => e * r / 100;
export {
  t as getPercentageOfValue,
  n as getPixelValueFromPercent
};
